/*
 * @Author: FengXiao
 * @Date: 2020-05-13 15:29:36
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-08-18 11:10:14
 */
import filters from './filters';
import methods from './methods';

export default {
  filters,
  methods,
};
